/**
 * Retorna as iniciais do nome.
 * Aceita string (nome) ou objeto com propriedade name (ex.: usuário).
 * @param {string|{ name?: string }} cNomeOuUsuario
 * @returns {string}
 */
const obterIniciaisDoNome = (cNomeOuUsuario) => {
  const cNome = typeof cNomeOuUsuario === "string" ? cNomeOuUsuario : cNomeOuUsuario?.name

  if (!cNome) return ""

  if (!cNome.includes(" ")) {
    return cNome[0].toUpperCase()
  }

  const mPalavras = cNome.split(" ")
  const cPrimeiraLetra = mPalavras[0][0]
  const cUltimaLetra = mPalavras[mPalavras.length - 1][0]

  return (cPrimeiraLetra + cUltimaLetra).toUpperCase()
}

export default obterIniciaisDoNome
